import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorPanel } from '../ErrorPanel';
import { useDataTest } from './useDataTest/useDataTest';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const DataTestError = ({
  children
}) => {
  const {
    errorId,
    hasError,
    onRetry
  } = useDataTest();
  if (hasError) {
    return /*#__PURE__*/_jsx(ErrorPanel, {
      errorId: errorId,
      onSubmit: onRetry,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dataTest.panel.error.generic.title"
      }),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dataTest.panel.error.generic.description"
      })
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};